import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SelectedSeat } from 'src/app/2dmap/types';
import { SelectedSeatItemComponent } from '../selected-seat-item/selected-seat-item.component';

@Component({
  selector: 'seat-selection-summary-mobile',
  standalone: true,
  templateUrl: './seat-selection-summary-mobile.component.html',
  styleUrls: ['./seat-selection-summary-mobile.component.css'],
  imports: [CommonModule, SelectedSeatItemComponent],
})
export class SeatSelectionSummaryMobileComponent {
  @Input() selectedSeats: SelectedSeat[] = [];
  @Output() goToCheckout = new EventEmitter()
  expanded = false;

  get subTotal() {
    return this.selectedSeats.reduce((prev, ac) => (prev += ac.price), 0);
  }

  onExpandToggle() {
    this.expanded = !this.expanded;
  }
}
